<template>
<div class="container container--reset-padding listing-header search-header" 
     v-bind:class="{'sr-only': hide}" >

    <div class="section-heading">
        <h1 class="heading-2">{{ title }}</h1>
        <div class="section-heading__links"></div>
    </div>
</div>
</template>

<style lang="scss">
.container.sr-only,
.container.sr-only h1 {
    opacity: 0;
    height: 0;
}
</style>

<script>
export default {
    name: 'SectionHeading',
    props: {
        title: String,
        hide: Boolean
    }
}
</script>
